import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { UPPERCASE_INPUT } from "../../../Forms/formStyles";
import Supplier from "../../Supplier";
import { SupplierFormProps } from "../SupplierFormProps";
import { TextFieldInput } from "../../../Forms/TextFieldInput";

export const SupplierGsdbForm = ({ disabledFields }: SupplierFormProps) => {
  const { control } = useFormContext<Supplier>();

  return (
    <BorderedFormGrid>
      <Grid item xs={3}>
        <TextFieldInput
          name="Gsdb"
          control={control}
          label="GSDB"
          required
          inputProps={UPPERCASE_INPUT}
          disabledFields={disabledFields}
        />
      </Grid>
      {/* PLACEHOLDER PARENT GSDB */}
      <Grid item xs={3} />
      {/* PLACEHOLDER Location Type */}
      <Grid item xs={3} />
      {/* PLACEHOLDER */}
      <Grid item xs={3} />
    </BorderedFormGrid>
  );
};
